import { useEffect, useMemo, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DotsLoader } from "../../ui/Loader/dotsLoader";
import { setSelectedBot } from "../../../state/actions/domain";
import { setBotWaitLoader } from "../../../state/actions/loader";
import { setClearCacheForSpinnetBot, setHideChatwidget, setHideDefaultHomepageBot } from "../../../state/actions/bot";
import { useNavigate } from "react-router-dom";
import { startConversation } from "../../../services/socket/socketEvents";
import { getAuthData } from "../../../services/storage/LocalStorage";
import { createConversation } from "../../../state/actions/chats";
import { withOutInitSocket } from "../../../state/actions/socket";
import { createConversationId } from "../../../utils/conversationUtils";
import { useOnlineStatus } from "../../../services/customHooks/useOnlineStatus";

export const IframeView = ({
  isLoading,
  baseUrl,
  botId,
  email,
  mobileSession,
  appType,
  platform = "web",
  conversationId,
  userDomain = "onship",
  version = "1.0.0",
  isDefaultHomePageBot,
  botSubscriptions,
  refreshToken,
  connectionId
}) => {

  baseUrl = baseUrl.includes('https') ? baseUrl : `https://${baseUrl}`
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authData = getAuthData();
  const selectedDomain = useSelector((state) => state.domain?.selectedDomain);
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);
  const clearCacheForSpinnetBot = useSelector((state) => state.bot?.clearCacheForSpinnetBot);
  const [initialClearCache] = useState(clearCacheForSpinnetBot);
  const isUserOnline = useOnlineStatus();
  let bots = botSubscriptions; 
  const src = useMemo(() => {
    const qp = {
      email,
      mobileSession,
      appType,
      conversationId,
      botId,
      version,
      platform,
      userDomain,
      isHomepage: isDefaultHomePageBot ? "true" : "false",
      clearCache: isDefaultHomePageBot ? String(initialClearCache) : "false",
      refreshToken,
      connectionId
    };

    const searchParams = new URLSearchParams();
    Object.entries(qp).forEach(([key, val]) => {
      searchParams.append(key, `"${val}"`);
    });

    return `${baseUrl}?${searchParams.toString()}`;
  }, [
    email, mobileSession, appType, conversationId, botId,
    version, platform, userDomain, baseUrl,
    isDefaultHomePageBot, initialClearCache
  ]);

  const handleBotClick = useCallback(async (value) => {
    const userId = authData?.user?.userId;
    if (value.customFrontEnd) {
      dispatch(setHideChatwidget());
    }
    dispatch(withOutInitSocket(true))
    dispatch(setHideDefaultHomepageBot());
    const conversationId = await createConversationId(userId, value?.botId);
    dispatch(createConversation(userId, value?.botId, selectedDomain));
    startConversation(userId, {
      conversationId: conversationId,
      botId: value?.botId,
      userDomain: selectedDomain
    });
    dispatch(setBotWaitLoader(true));
    dispatch(setSelectedBot(value));

  }, [dispatch]);

  const handleBannerClick = async (value) => {
    console.log('handleBannerClick', value)
    const userId = authData?.user?.userId;

    const redirectMap = {
      Apps: "/app/catalog",
      Contacts: "/app/contacts",
      myProfileScreenOnship: "/app/my-profile",
    };

    const target = redirectMap[value?.data];
    if (target) {
      navigate(target);
      dispatch(setHideDefaultHomepageBot());
    } else if (value?.type === 'bot') {
      if (bots.length === 0) return
      dispatch(setHideDefaultHomepageBot());
      dispatch(withOutInitSocket(true))

      const botDetails = bots?.find(bot => bot?.botId === value?.data);
     
      if (botDetails) {
        const userDomain = botDetails.userDomain;
        const conversationId = await createConversationId(userId, value?.data);
        dispatch(createConversation(userId, value?.botId, userDomain));

        startConversation(userId, {
          conversationId: conversationId,
          botId: value?.data,
          userDomain: userDomain
        });
        dispatch(setBotWaitLoader(true));
        dispatch(setSelectedBot(botDetails));
      }
    }
  }


  useEffect(() => {
    const handleIframeMessage = (event) => {
      const { payload,handlerName } = event.data || {};
      const parsedPayload = (handlerName==='handleBotClick' || handlerName==='handleBannerClick') && typeof payload === 'string' ? JSON.parse(payload) : payload;
      const {type,value} = parsedPayload || {};

      if (type === "bot_click") {
        handleBotClick(value);
      } else if (type === "banner_click") {
        handleBannerClick(value);
      }
    };

    window.addEventListener("message", handleIframeMessage);
    return () => {
      window.removeEventListener("message", handleIframeMessage);
    };
  }, [handleBotClick, handleBannerClick]);


  useEffect(() => {
    if (isLoading) {
      const timeout = setTimeout(() => {
        dispatch(setBotWaitLoader(false));
      }, 3000);
      return () => clearTimeout(timeout);
    }
  }, [isLoading, dispatch]);

  useEffect(() => {
    if (isLoading) {
      setIsIframeLoaded(false);
    }
  }, [isLoading]);

  useEffect(() => {
    if (isUserOnline && baseUrl) {
      setIsIframeLoaded(true);
    }
  }, [isUserOnline]);

  const showLoader = isLoading || !isIframeLoaded;

  return (
    <>
      {showLoader && (
        <div className="home-component relative align-center justify-center">
          <DotsLoader />
        </div>
      )}
      {!isLoading &&
        <iframe
          allowFullScreen
          src={src}
          style={{ width: "100%", height: "100%", border: "none", display: showLoader ? "none" : "block", }}
          title="Chatbot Iframe"
          onLoad={() => {
            setIsIframeLoaded(true);
            // if (clearCacheForSpinnetBot && isDefaultHomePageBot) {
            //   dispatch(setClearCacheForSpinnetBot(false));
            // }
          }}
        />
      }
    </>
  );
};